var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "teaser-option" },
    [
      _c(
        "v-btn",
        {
          staticClass: "remove",
          attrs: { disabled: _vm.disabled || _vm.selectedTeaser < 2 },
          on: { click: _vm.decrease }
        },
        [_c("v-icon", [_vm._v("remove")])],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "value" }, [
        _c("span", [
          _c(
            "span",
            {
              key: "Tlevel" + "-" + _vm.selectedTeaser,
              staticClass: "spread-label"
            },
            [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "BetSlip.tab.TEASER.option.spread.T" + _vm.selectedTeaser
                  )
                ) + "\n        "
              ),
              _vm._v(" "),
              _vm.currentSpread
                ? _c("span", { staticClass: "spread" }, [
                    _c("br"),
                    _vm._v("+ " + _vm._s(this.currentSpread))
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.samesport
                ? _c("span", { staticClass: "spread" }, [
                    _c("br"),
                    _vm._v(
                      _vm._s(_vm.$t("BetSlip.tab.TEASER.option.spread.mixed"))
                    )
                  ])
                : _vm._e()
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "v-btn",
        {
          staticClass: "add",
          attrs: { disabled: _vm.disabled || _vm.selectedTeaser > 2 },
          on: { click: _vm.increase }
        },
        [_c("v-icon", [_vm._v("add")])],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cc722fda", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc722fda","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/betslip/teaserOption.vue
// module id = null
// module chunks = 